var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ff305e;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.16,19.77c-13.27,0-24.02,10.75-24.02,24.02v31.92c0,8.44,6.85,15.28,15.28,15.28s15.28-6.85,15.28-15.28c0-12.23,17.47-14.14,17.47-31.92,0-13.27-10.75-24.02-24.02-24.02ZM29.8,70.79c-.29.15-.61.23-.92.23-.72,0-1.42-.39-1.78-1.08-.51-.98-.13-2.19.85-2.7,1.22-.63,1.97-1.88,1.97-3.25s-.76-2.61-1.97-3.25c-.98-.51-1.36-1.72-.85-2.7.51-.98,1.72-1.36,2.7-.85,2.55,1.32,4.13,3.93,4.13,6.8s-1.58,5.47-4.13,6.8ZM46.73,60.69c-.14.03-.28.04-.42.04-.92,0-1.75-.64-1.95-1.58-.23-1.08.46-2.14,1.54-2.37,7.17-1.52,11.76-8.59,10.23-15.76-1.52-7.17-8.59-11.76-15.76-10.23-7.17,1.52-11.76,8.59-10.23,15.76.23,1.08-.46,2.14-1.54,2.37-1.08.24-2.14-.46-2.37-1.54-1.98-9.32,3.99-18.52,13.31-20.5,9.32-1.99,18.52,3.99,20.5,13.31,1.98,9.32-3.99,18.52-13.31,20.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.82,11.51c-1.04-.38-2.19.16-2.56,1.2-.38,1.04.16,2.19,1.2,2.56,8.42,3.04,15.03,9.6,18.14,18,.3.81,1.06,1.31,1.88,1.31.23,0,.47-.04.69-.12,1.04-.38,1.56-1.53,1.18-2.57-3.52-9.5-11-16.93-20.53-20.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M82.74,29.2c-4.31-11.7-13.51-20.83-25.23-25.08-1.04-.37-2.19.16-2.56,1.2-.38,1.04.16,2.19,1.2,2.56,10.61,3.84,18.93,12.11,22.84,22.7.3.81,1.06,1.31,1.88,1.31.23,0,.46-.04.69-.12,1.04-.38,1.57-1.53,1.18-2.57Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause8);
export default __webpack_public_path__ + "static/media/cause_8.92b1289541476e6725207f5a6f720124.svg";
export { ForwardRef as ReactComponent };